export const CMS_CAROUSEL_SCROLL_DIRECTION = 'CMS_CAROUSEL_SCROLL_DIRECTION';
export const CMS_CAROUSEL_SCROLL_STEP = 'CMS_CAROUSEL_SCROLL_STEP';
export const CMS_PUSH_TRACKING_BANNERS = 'CMS_PUSH_TRACKING_BANNERS';
export const CMS_CLEAN_TRACKING_BANNERS = 'CMS_CLEAN_TRACKING_BANNERS';
